/**
 * 模块 - 驾驶舱/绩效复盘 - 英文
 */
export default {
  // 直接作为根级属性，方便使用 $t('cockpitManage.xxx')
  cockpitManage: {
    completion1: 'Completion',
    completed2: 'Completed',
    uncompleted3: 'Uncompleted',
    completion4: 'Completion',
    completed5: 'Completed',
    uncompleted6: 'Uncompleted',
    indicator7: 'Indicator',
    orderCount8: 'Orders',
    visitCount9: 'Visits',
    commitmentCount10: 'Commitments',
    wechatCount11: 'WeChat Adds',
    callCount12: 'Calls',
    quantity13: 'Quantity',
    channelProportion14: 'Channel Share',
    channelProportion15: 'Channel Share',
    channelConversion16: 'Channel Conversion',
    startDate17: 'Start Date',
    endDate18: 'End Date',
    dashboard49: 'Dashboard',
    currentTimeProgress50: 'Current Time Progress',
    performanceCompletion51: 'Performance Completion',
    learningRevenue52: 'Learning Machine Revenue',
    target53: 'Target',
    supervisorRevenue54: 'Supervisor Revenue',
    target55: 'Target',
    channelConversionOverview56: 'Channel Conversion Overview',
    processMetrics57: 'Process Metrics',
    funnelMetrics58: 'Funnel Metrics',
    clueCall59: 'Clue Calls',
    callWechat60: 'Call to WeChat',
    wechatCommitment61: 'WeChat to Commitment',
    commitmentVisit62: 'Commitment to Visit',
    visitConversion63: 'Visit Conversion',
    salesPerformanceProgress64: 'Sales Performance Progress',
    redBelowTimeProgress65: 'Red indicates completion below time progress',
    salesFollowUpStats66: 'Sales Follow-up Statistics',
    remindSalesDaily67: 'Please remind sales staff to report daily on DingTalk',
    statsDate68: 'Stats Date',
    selectMonth69: 'Select Month',
    selectDatePlaceholder: 'Select date',

    // 基础参数设置
    targetParamsSetting: 'Target Parameters Settings',
    avgPriceLabel: 'Average Selling Price',
    conversionRate: 'Conversion Rate',
    visitRate: 'Visit Rate',
    promiseVisitRate: 'Promise Visit Rate',
    addWechatRate: 'Add WeChat Rate',
    supervisorNewSignRate: 'Supervisor New Sign Rate',
    supervisorAvgPrice: 'Supervisor Avg Price',
    enterAvgPrice: 'Please enter average selling price',
    enterConversionRate: 'Please enter conversion rate',
    enterVisitRate: 'Please enter visit rate',
    enterPromiseVisitRate: 'Please enter promise visit rate',
    enterAddWechatRate: 'Please enter add wechat rate',
    enterSupervisorNewSignRate: 'Please enter supervisor new sign rate',
    enterSupervisorAvgPrice: 'Please enter supervisor avg price',
    edit: 'Edit',
    save: 'Save',
    reset: 'Reset',
    yuan: 'Yuan',

    // 上报提醒设置
    reportReminderSettings: 'Report Reminder Settings',
    reminderTime: 'Reminder Time',
    everyday: 'Everyday',
    reminderDescription: 'Remind staff who need to complete task reports via DingTalk SMS',
    timesUnit: ' times',

    // 提示信息
    tip1: 'The default average selling price is calculated from the average retail price of all learning machines sold by the dealer last month',
    tip2: 'If no learning machines were sold last month, the national average selling price is used',
    tip3: 'The default conversion rate, visit rate, promise visit rate, add WeChat rate, supervisor new sign rate, and supervisor avg price adopt industry standard recommended values',
    tip4: 'All parameters can be personalized through editing. After saving, the unstarted targets will take effect',
    tip5: 'Click reset to restore the corresponding parameter values to the system default values. After successful reset, the original targets will take effect',

    // CockpitTarget - target management/setting
    targetManagement: 'Target Management',
    noTargetThisMonthTip: 'You have not set a target this month. Add one now.',
    newTarget: 'New Target',
    addTarget: 'Add Target',
    monthlyTarget: 'This Month Target',
    selfBuilt: 'Self-built',
    superior: 'Superior',
    targetRevenue: 'Target Revenue',
    currentRevenue: 'Current Revenue',
    actualRevenue: 'Actual Revenue',
    completion: 'Completion',
    timeProgress: 'Time Progress',
    notStarted: 'Not Started',
    remainingDays: 'Remaining {days} days',
    view: 'View',
    edit: 'Edit',
    delete: 'Delete',
    operationReminder: 'Operation Reminder',
    deleteTargetConfirmTip: 'Deleting the target will clear submitted performance data, and the included sales targets will also be cleared. Please proceed with caution.',

    exit: 'Exit',
    targetDetail: 'Target Detail',
    targetSetting: 'Target Setting',
    targetCycle: 'Target Cycle',
    selectMonthPlaceholder: 'Select month',
    superiorAddedTargetTip: 'Your superior has added a target for this month. You can allocate based on the target below.',
    learningMachinePart: 'Learning Machine Part',
    supervisorPart: 'Supervisor Part',
    estimatedRevenue: 'Estimated Revenue',
    estimateBasedOnOfficialRetailPrice: 'Estimated based on official reference retail price',
    model: 'Model',
    targetUnits: 'Target Units',
    totalTargetRevenue: 'Total Target Revenue',
    promoteTarget: 'Increase My Target',
    myTarget: 'My Target',
    supervisorIncomeDefaultTip: 'Supervisor income defaults to learning machine units',
    supervisorNewSignRateTip1: 'You can adjust supervisor new sign rate and unit price',
    supervisorNewSignRateTip2: 'in Cockpit Basic Settings,',
    supervisorNewSignRateTip3: 'or directly enter your expected target revenue',
    totalRevenue: 'Total Revenue',
    nextStepAssignTarget: 'Next: Assign Targets',
    smartAssignedTip: 'Targets have been intelligently allocated to all employees based on your target/superior target. You can adjust learning machine/supervisor targets.',
    targetSource: 'Target Source',
    selfBuiltTarget: 'Self-built Target',
    superiorAgent: 'Superior Agent',
    addStaff: 'Add Staff',
    ratioMode: 'Ratio Mode',
    revenueMode: 'Revenue Mode',
    restoreDefaultPlan: 'Restore Default Plan',
    learningRevenueRatio: 'Learning Revenue Ratio',
    learningRevenue: 'Learning Revenue',
    supervisorRevenueRatio: 'Supervisor Revenue Ratio',
    supervisorRevenue: 'Supervisor Revenue',
    totalTarget: 'Total Target',
    targetBreakdown: 'Target Breakdown',
    total: 'Total',
    backToTargetSetting: 'Back to Target Setting',
    confirmModify: 'Confirm Changes',
    complete: 'Complete',
    select: 'Select',
    name: 'Name',
    staffRole: 'Staff Role',
    tipTitle: 'Tip',
    switchModeConfirmTip: 'Switch input mode?',
    switchModeImpactTip: 'All employee revenue ratios will be recalculated. Please proceed with caution.',
    restoreDefaultTip1: 'Due to staff changes, learning/supervisor revenue ratios will be restored to the default plan.',
    restoreDefaultTip2: 'All employee ratios will be recalculated. Please proceed with caution.',
    salesName: 'Sales Name',
    assignRatio: 'Allocation Ratio',
    revenueTarget: 'Revenue Target',
    processTarget: 'Process Target',
    processTargetTip: 'Process targets are calculated based on default ratios. If not as expected, adjust parameters in Cockpit Basic Settings.',
    iKnow: 'I know',
    submitTargetConfirmPrefix: 'After submitting, the target will be distributed to selected employees and will take effect on ',
    submitTargetConfirmSuffix: '. Confirm to continue?',
    deleteStaffImpactTip: 'Deleting staff will clear their performance ratio/revenue targets, and included sales targets will also be cleared. Please proceed with caution.',
    pleaseEnterLearningTarget: 'Please enter learning machine target',
    pleaseEnterSupervisorTarget: 'Please enter supervisor target',
    previousMonthTargetLabel: 'Previous month target: ',
    actualCompletedLabel: 'Actual completed: ',
    staffAddedCount: 'Added {count} staff',
    actualRevenueLabel: 'Actual revenue: ',
    targetRevenueLabel: 'Target revenue: ',
    currentRevenueLabel: 'Current revenue: ',
    effectiveDate: '{year}-{month}-01',
    learningMachinePartPrefix: 'Learning Machine: ',
    supervisorPartPrefix: 'Supervisor: '
    ,
    estimatedTargetPrefix: 'Estimated target ',
    targetPrefix: 'Target ',
    learningMachinePartWithDash: 'Learning Machine - ',
    supervisorPartWithColon: 'Supervisor: '
    ,
    myLearningRevenueNotBelow: 'My learning machine revenue target cannot be lower than {amount}',
    mySupervisorRevenueNotBelow: 'My supervisor revenue target cannot be lower than {amount}'
  },
  cockpit: {
    // ... existing keys ...
    resultOutcome: 'Result Outcome',
    processOutcome: 'Process Outcome',
    workSpotCheck: 'Work Spot Check',
    statsDate: 'Stats Date',
    staffName: 'Staff Name',
    reportDate: 'Report Date',
    reportDatePlaceholder: 'Report Date',
    salesPerson: 'Sales Person',
    date: 'Date',
    totalAmount: 'Total Amount',
    totalTarget: 'Total Target',
    totalTargetCompletion: 'Total Target Completion',
    learningMachineAmount: 'Learning Machine Amount',
    learningMachineTarget: 'Learning Machine Target',
    learningMachineCompletion: 'Learning Machine Completion',
    supervisorAmount: 'Supervisor Amount',
    supervisorTarget: 'Supervisor Target',
    supervisorCompletion: 'Supervisor Completion',
    supervisorNewSign: 'Supervisor New Sign',
    supervisorRenew: 'Supervisor Renew',
    clueNum: 'Clue Count',
    clueNumShort: 'Clues',
    callNum: 'Calls',
    callTarget: 'Call Target',
    callRate: 'Call Rate',
    callRecord: 'Call Record',
    wechatNum: 'WeChat Adds',
    wechatTarget: 'WeChat Target',
    wechatRate: 'WeChat Rate',
    wechatRecord: 'WeChat Record',
    commitmentNum: 'Commitments',
    commitmentTarget: 'Commitment Target',
    commitmentRate: 'Commitment Rate',
    commitmentRecord: 'Commitment Record',
    instoreNum: 'Visits',
    instoreTarget: 'Visit Target',
    instoreRate: 'Visit Rate',
    instoreRecord: 'Visit Record',
    orderNum: 'Orders',
    orderTarget: 'Order Target',
    orderRecord: 'Order Record',
    conversionRate: 'Conversion Rate',
    orderDetail: 'Order Detail',
    orderType: 'Order Type',
    view: 'View',
    selectMonth: 'Select Month',
    learningMachineSupervisor: 'Learning Machine-Supervisor',
    learningMachine: 'Learning Machine',
    supervisor: 'Supervisor',
    snCode: 'SN Code',
    learningMachineModel: 'Learning Machine Model',
    adaptiveAccount: 'Adaptive Account',
    orderAmount: 'Order Amount',
    orderSplit: 'Order Split',
    splitDetail: 'Split Detail',
    credential: 'Credential',
    noCredential: 'No Credential',
    close: 'Close',
    splitDetailTitle: 'Split Detail',
    person: 'Person',
    splitRate: 'Split Rate',
    clueName: 'Clue Name',
    cluePhone: 'Clue Phone',
    clueSource: 'Clue Source',
    followUploadTime: 'Follow Upload Time',
    credentialDetail: 'Credential Detail',
    descCredential: 'Description/Credential',
    collabSplit: 'Collaborative Split',
    record: 'Record',
    dailySummary: 'Daily Summary',
    processOutcomeExport: 'Process Outcome Export',
    resultOutcomeExport: 'Result Outcome Export',
    todayWorkContent: 'Today Work Content:',
    deleteSuccess: 'Deleted successfully'
  }
}
